///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";

import { getAllBids } from "../api/bids";
import { isCancel } from "../api/axios";
import getSearchAllBidsParams from "../helpers/getSearchAllBidsParams";

export const initialState = {
  isFetching: false,
  bids: null,
  isError: false,
  searchTerm: "",
  modes: [],
  status: [],
  sortColumn: "",
  sortOrder: "",
  pageNumber: 1,
  limit: 25,
  totalCount: 0,
  columnFilterMenu: { field: null, visible: false },
  columnWidths: {}
};

const searchAllBidsSlice = createSlice({
  name: "searchAllBids",
  initialState,
  reducers: {
    requestAllBids: state => {
      state.isFetching = true;
      state.isError = false;
      state.bids = null;
    },
    receiveAllBidsSuccess: (state, { payload }) => {
      state.bids = payload.results;
      state.totalCount = payload.totalCount;
      state.isFetching = false;
      state.isError = false;
    },
    receiveAllBidsFailure: state => {
      state.isFetching = false;
      state.isError = true;
      state.bids = null;
    },
    setSearchTerm: (state, { payload }) => {
      state.searchTerm = payload;
      state.pageNumber = initialState.pageNumber;
    },
    setModeFilters: (state, { payload }) => {
      state.modes = payload;
      state.pageNumber = initialState.pageNumber;
    },
    setStatusFilters: (state, { payload }) => {
      state.status = payload;
      state.pageNumber = initialState.pageNumber;
    },
    setSortParams: (state, { payload }) => {
      state.sortColumn = payload.sortColumn;
      state.sortOrder = payload.sortOrder;
      state.pageNumber = initialState.pageNumber;
    },
    setPaginationParams: (state, { payload }) => {
      state.pageNumber = payload.pageNumber;
      state.limit = payload.limit;
    },
    setColumnFilterMenu: (state, { payload: { field, visible } }) => {
      state.columnFilterMenu = { field, visible };
    },
    setColumnWidth: (state, { payload: { width, field } }) => {
      state.columnWidths[field] = width;
    }
  }
});

export const {
  requestAllBids,
  receiveAllBidsSuccess,
  receiveAllBidsFailure,
  setSearchTerm,
  setModeFilters,
  setStatusFilters,
  setSortParams,
  setPaginationParams,
  setColumnFilterMenu,
  setColumnWidth
} = searchAllBidsSlice.actions;

export const searchAllBidsReducer = searchAllBidsSlice.reducer;

export const fetchAllBids = () => async (dispatch, getState) => {
  const params = getSearchAllBidsParams(getState().searchAllBids);
  dispatch(requestAllBids());
  window.scrollTo(0, 0);

  getAllBids(params)
    .then(({ data }) => {
      dispatch(receiveAllBidsSuccess(data));
    })
    .catch(e => {
      if (!isCancel(e)) {
        dispatch(receiveAllBidsFailure());
      }
    });
};
